import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { changeLanguage, LOCALES } from 'common/i18n';
import { LocalizationStore } from 'common/i18n/store';
import { Section } from 'common/components/items-menu/types';
import { SelectReact } from 'common/components/select';
import { ChangeEvent } from 'common/components/select/types';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonSize } from 'common/components/button/constants';
import { Directions } from 'common/components/drop-menu/types';
import { react2panel } from 'common/util/react2panel';
type LanguageItem = {
  label: string;
  value: string;
  locale: string;
  isSelected: boolean;
};
export const getLocaleMenuSections = (_ref: {
  i18n: LocalizationStore;
}): Array<Section<string, EmptyObj, LanguageItem>> => {
  let {
    i18n
  }: {
    i18n: LocalizationStore;
  } = _ref;
  return [{
    items: LOCALES.map(locale => {
      return {
        label: locale.displayName,
        value: locale.code,
        locale: locale.code,
        isSelected: locale.code === i18n.language
      };
    })
  }];
};
export const LanguageSelector = () => {
  const translation = useTranslation();
  const onChange = (item: LanguageItem) => {
    changeLanguage(item.locale);
  };
  return <SelectReact sections={getLocaleMenuSections({
    i18n: translation
  })} theme={SelectTheme.Tertiary} size={ButtonSize.Large} alwaysShowCaret menuWidth={140} menuHeight={450} icon={{
    leftIcon: "globe"
  }} menuAlignment={Directions.DownRight} onChange={ev => onChange((ev as ChangeEvent).detail.item as LanguageItem)} data-sentry-element="SelectReact" data-sentry-component="LanguageSelector" data-sentry-source-file="index.tsx" />;
};
export const LanguageSelectorEl = react2panel("mp-language-selector", LanguageSelector);